import { useLocation } from "react-router";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Image,
  Text,
  useBreakpointValue,
  useColorModeValue,
} from "@chakra-ui/react";
import useCheckLogin from "../../hook/useCheckLogin";
import Balance from "../Balance/Balance";
import ClearCashRegisterButton from "../ClearCash/ClearCashRegisterButton";
import MusicToggleButton from "./HeaderComponents/MusicToggleButton";
import ReloadButton from "./HeaderComponents/ReloadButton";
import LoginButton from "./HeaderComponents/LoginButton";
import UserButton from "./HeaderComponents/UserButton";
import LngButton from "./HeaderComponents/LngButton";
import AnnouncementButton from "./HeaderComponents/AnnouncementButton";
import MarqueeListMobile from "../marquee/marqueeListMobile";
import BetRecordButton from "../BetRecordButton/BetRecordButton";

const isCredit = process.env.REACT_APP_CREDIT == 1;

const Header = () => {
  const { t, i18n } = useTranslation();
  //const i18n = (key) => t(`common.${key}`);
  const i18n_header = (key) => t(`header.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_profile = (key) => t(`profile.${key}`);

  const iconBg = useColorModeValue("#E9E8F2", "#262D47");
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const location = useLocation(); //返回一個location對象，其中包含當前URL的信息。它與window.location最大的區別是，它不會引起頁面重新加載。你可以在任何地方使用它，包括React Hooks組件中。

  const profilePath = useBreakpointValue({
    base: "profile",
    sm: "profile/data",
  });

  const gradientStyle = {
    color: "white",
    WebkitTextStroke: "1px #804ed2",
    textStroke: "1px #804ed2",
    textShadow: `
    -1px -1px 0 #804ed2,  
     1px -1px 0 #804ed2,
    -1px 1px 0 #804ed2,
     1px 1px 0 #804ed2
  `,

    display: "inline-block",
  };

  return (
    <Box
      width={{
        base: `100%`,
        xl: `100%`,
      }}
      minHeight={{
        base: "70px",
        sm: "70px",
        md: "100px",
        xl: isMachineDomain || isMachineUser ? "150px" : "100px",
      }}
      position="fixed"
      mx="auto"
      top="0px"
      bgImage={{
        base: `url(${COMMON_WEB_PATH}/now888/header/header_background_mobile_.png)`,
        lg:
          isMachineDomain || isMachineUser
            ? `url(${COMMON_WEB_PATH}/now888/header/machine_header_background.webp)`
            : `url(${COMMON_WEB_PATH}/now888/header/pc_header_bg.png)`,
      }}
      _after={{
        lg: {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          bgImage:
            isMachineDomain || isMachineUser
              ? null
              : `${COMMON_WEB_PATH}/now888/header/pc_header_black.png`,
          bgSize: "100%100%",
          bgRepeat: "no-repeat",
          bgPosition: "center",
          w: "100%",
          h: "110%",
          pointerEvents: "none", // 確保不會阻止點擊事件
        },
      }}
      bgSize="100% 100%"
      zIndex={{
        base: "999",
        sm: "1001",
      }}
      borderBottomLeftRadius={{
        base: "none",
        lg: "15px",
      }}
      borderBottomRightRadius={{
        base: "none",
        lg: "15px",
      }}
      display="flex"
      pt={{
        base: "0px",
        xl: isMachineUser || isMachineDomain ? "20px" : "0px",
      }}
      alignItems={
        isMachineUser
          ? "flex-start"
          : {
              base: "flex-start",
              lg: "center",
            }
      }
      justifyContent="space-between"
      // borderColor={headerBorder}
      pr={{
        base: "1%",
        md: "1%",
        lg: "1%",
        xl: "5%",
      }}
      pl={{
        base: isLogin ? "1%" : "3%",
        md: isLogin ? "1%" : "3%",
        lg: isMachineDomain || isMachineUser ? "3%" : "6%",
        xl: isMachineDomain || isMachineUser ? "1%" : "8%",
      }}
      // boxShadow={{
      //   base: "0 0 10px #804ed2, 0 0 20px #804ed2", // 光晕
      //   lg: "none",
      // }}
      transition="all 0.3s ease" // 過渡
    >
      {/* <HeaderAppDownload /> */}

      <Flex
        alignItems={{
          base: "flex-start",
          md: "center",
        }}
        pt={{
          base: "5px",
          md: "unset",
        }}
        justifyContent={{
          base: "flex-end",
          sm: "space-between",
        }}
        pl={{
          md: "0px",
          base: "0px",
          // lg: isGameBox ? "0px" : "245px",
        }}
        pr={{
          md: "0px",
          base: "0px",
        }}
        pb={{
          base: "0px",
          sm: "0px",
        }}
        width="100%"
        height="100%"
      >
        {isMachineUser || isMachineDomain ? (
          <>
            {/* <AbsoluteCenter top="45%">
              <Image
                w={{
                  base: "200px",
                  xl: "280px",
                }}
                src={`${COMMON_WEB_PATH}/now888/machine_logo_.png`}
              />
            </AbsoluteCenter> */}
            <Flex gap="25px" alignItems={"center"}>
              {/* 餘額 */}
              <Balance />
              <Flex gap="10px">
                {/* 棄分按鈕 */}
                <ClearCashRegisterButton />
                {/* 投注記錄 */}
                <BetRecordButton />
              </Flex>
            </Flex>
            <Flex gap="30px">
              <Flex
                //w="auto"
                minW="160px"
                px="50px"
                gap="8px"
                height={{
                  base: "60px",
                  //xl: "85px",
                  xl: isMachineUser ? "65px" : "65px",
                }}
                bgImage={`url('${COMMON_WEB_PATH}/now888/header/uid_banner.png')`}
                bgPosition="center"
                bgRepeat="no-repeat"
                bgSize="100%100%"
                alignItems={"center"}
                justifyContent={"center"}
                shadow="sm"
              >
                <Text
                  color="transparent"
                  sx={gradientStyle}
                  fontSize={{
                    base: "xl",
                    //xl: "2xl",
                    xl: isMachineUser ? "30px" : "30px",
                  }}
                  fontWeight="900"
                >
                  NO.{memberInfo?.uid || "-"}
                </Text>
              </Flex>
              <Flex gap="10px">
                <LngButton />
                {/* 重整按鈕 */}
                <ReloadButton />
                {/* 音樂按鈕 */}
                <MusicToggleButton />
              </Flex>
            </Flex>
          </>
        ) : (
          <>
            <Flex
              alignItems={{
                base: `flex-start`,
                lg: `center`,
              }}
              gap={{
                base: 0,
              }}
              justifyContent={"space-between"}
              w={{
                base: "100%",
                md: "100%",
                xl: "100%",
              }}
            >
              <Box
                display={{
                  base: "none",
                  lg: "block",
                }}
                w={{
                  lg: "210px",
                  xl: "300px",
                }}
                h={{
                  base: "85px",
                }}
                as={Link}
                to="/"
                position="relative"
                zIndex={1}
              >
                {/* <AbsoluteCenter
                  left={{
                    md: "50%",
                    lg: "50%",
                    xl: "50%",
                  }}
                  w="100%"
                >
                  <Image
                    w="200px"
                    src={`${COMMON_WEB_PATH}/now888/machine_logo_.png`}
                  />
                </AbsoluteCenter> */}
              </Box>

              <Box
                as="section"
                flex="1"
                display={{
                  base: "block",
                  lg: "none",
                }}
                position="absolute"
                bottom="0px"
                w="100%"
                left="0px"
                bgImage={`url('${COMMON_WEB_PATH}/now888/header/header_background_marquee_mobile.svg')`}
                bgSize={"cover"}
                bgRepeat={"no-repeat"}
                zIndex={-1}
                h={{
                  base: "22px",
                  md: "30px",
                }}
                borderTopLeftRadius={"100px"}
                borderTopRightRadius={"100px"}
              >
                <MarqueeListMobile />
              </Box>
              <Flex
                w={{
                  base: "100%",
                  lg: "auto",
                }}
                justifyContent={{
                  base: "space-between",
                  sm: "space-between",
                }}
                alignItems={"center"}
                gap="10px"
                zIndex={1}
              >
                <Box //電腦版
                  display={{
                    md: "flex",
                    base: "none",
                  }}
                  gap={{
                    md: "15px",
                    base: "5px",
                  }}
                  alignItems={`center`}
                >
                  {isLogin && <Balance />}
                </Box>
                {/* 手機版 */}
                <>
                  <Box
                    display={{
                      md: "none",
                      base: "flex",
                    }}
                  >
                    {" "}
                    {isLogin ? (
                      <Balance />
                    ) : (
                      <>
                        <ReloadButton />
                        <MusicToggleButton />
                      </>
                    )}
                  </Box>

                  {/* <AbsoluteCenter
                    display={{
                      base: "block",
                      lg: "none",
                    }}
                    top="35%"
                    as={Link}
                    to="/"
                  >
                    <Image
                      w={{
                        base: "105px",
                        md: "165px",
                      }}
                      src={`${COMMON_WEB_PATH}/now888/machine_logo_.png`}
                    />
                  </AbsoluteCenter> */}
                  <Flex
                    alignItems={{
                      base: "unset",
                      md: "center",
                    }}
                    gap="2.5px"
                  >
                    <Flex alignItems="center" gap="5px">
                      <Flex
                        display={{
                          base: isLogin ? "none" : "none",
                          md: "flex",
                        }}
                        gap="10px"
                      >
                        <Flex
                          display={{
                            base: "flex",
                            md: "none",
                            lg: "flex",
                          }}
                        >
                          {" "}
                          <MusicToggleButton />
                        </Flex>
                        <Flex>
                          <ReloadButton />
                        </Flex>
                      </Flex>
                      <Flex gap="5px">
                        <Flex align="center" gap="5px">
                          <LngButton />
                          <AnnouncementButton />
                        </Flex>
                        {isLogin ? <UserButton /> : <LoginButton />}
                      </Flex>
                    </Flex>
                  </Flex>
                </>
              </Flex>
            </Flex>
          </>
        )}
      </Flex>
    </Box>
  );
};

export default Header;
